<template>
  <div class="footer-actions">
    <b-button
        v-for="btn in buttons"
        :key="btn.text"
        :variant="btn.variant || 'primary'"
        @click="handleClick(btn)"
        class="footer-btn"
    >
      {{ btn.text }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'FooterActions',
  props: {
    /**
     * Array of button definitions:
     * [{ text: String, to: String (route), variant: String, onClick: Function }]
     */
    buttons: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick(btn) {
      if (btn.to) {
        this.$router.push(btn.to);
      } else if (typeof btn.onClick === 'function') {
        btn.onClick();
      }
    }
  }
};
</script>

<style scoped>
.footer-actions {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  max-width: 100vw;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: nowrap; /* reste sur une ligne, active scroll si déborde */
  overflow-x: auto;
  z-index: 200; /* au-dessus du contenu de la page */
}

.footer-btn, .footer-actions .btn {
  flex: 1 1 0;
  min-width: 70px;   /* taille minimale acceptable */
  max-width: 160px;  /* taille maximale */
  text-align: center;
  font-size: 1rem;
  padding: 0.75rem 0.5rem;
  /* Optionnel, pour égaliser la hauteur : */
  height: 45px;
  /* Pour empêcher le texte de déborder, et couper s’il le faut */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}


</style>
